<template>
  <div class="flex justify-center mt-12">
    <div
      class="w-full max-w-md bg-[#191822] rounded-[20px] p-6 border border-transparent shadow-xl relative"
    >
      <!-- Neon border -->
      <div
        class="absolute inset-0 rounded-[20px] pointer-events-none z-[-1] bg-gradient-to-tr from-pink-500 via-yellow-400 to-yellow-500 p-[2px]"
      ></div>

      <div class="bg-[#191822] rounded-[18px] p-6">
        <h2 class="text-white text-2xl font-bold text-center mb-4 font-orbitron">
          Commission Calculator
        </h2>

        <p class="text-white text-sm text-center mb-1">
          Calculate your commission based on your wager:
        </p>
        <p class="text-white text-xs text-center mb-4">
          Formula: <span class="text-[#E6007A]">(House Edge * Wager / 2) * 10%</span>
        </p>

        <div class="flex flex-col gap-3">
          <input
            v-model.number="wager"
            type="number"
            placeholder="Your Wager ($)"
            class="input-box text-center"
          />

          <select v-model="selectedGame" class="input-box text-center">
            <option v-for="game in games" :key="game.name" :value="game">
              {{ game.name }} ({{ game.edge }}%)
            </option>
          </select>
        </div>

        <div class="mt-6 text-center">
          <p class="text-sm text-white mb-1">
            ( <span class="text-[#E6007A]">{{ selectedGame.edge }}%</span> * ${{
              wager.toLocaleString()
            }}
            / 2 ) * 10% =
          </p>
          <p class="text-3xl font-extrabold" :class="highlightClass">
            ${{ commission.toFixed(2) }}
          </p>
          <p class="text-white text-xs mt-2">
            Estimated commission for ${{ wager.toLocaleString() }} wagered on
            {{ selectedGame.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <h1
    class="text-center w-full text-xl md:text-2xl mt-10 font-orbitron text-[#FFEB3B] drop-shadow-[0_0_10px_#FFEB3B]"
  >
    Commissions will be paid out weekly!
  </h1>
</template>

<script>
export default {
  data() {
    return {
      wager: 1000,
      selectedGame: { name: "Hi-Lo", edge: 1 },
      games: [
        { name: "Hi-Lo", edge: 1 },
        { name: "Dice", edge: 0.95 },
        { name: "Goat Run", edge: 4 },
        { name: "Keno", edge: 1 },
        { name: "G3 Tower", edge: 2 },
        { name: "Plinko", edge: 1 },
        { name: "Mines", edge: 1 },
        { name: "BlackJack", edge: 0.75 },
        { name: "Limbo", edge: 1 },
        { name: "Diamonds", edge: 1.71 },
        { name: "Wheel", edge: 1 },
        { name: "G3 Cards", edge: 2 },
        { name: "Slots", edge: 3 },
      ],
    };
  },
  computed: {
    commission() {
      return (((this.selectedGame.edge / 100) * this.wager) / 2) * 0.1;
    },
    highlightClass() {
      return "text-[#FFEB3B] drop-shadow-[0_0_10px_#FFEB3B]";
    },
  },
};
</script>

<style scoped>
.input-box {
  background-color: #2d1c63;
  border: none;
  border-radius: 10px;
  padding: 12px;
  color: white;
  font-weight: 500;
}
.input-box:focus {
  outline: none;
  background-color: #3e2a75;
}
</style>
